<template>
    <span v-if="logo">
      <span v-bind="logo.properties">
      <template v-if="logo.route">
        <a
            :to="getURLLocalGlobal(logo.route.url)"
            :target="logo.route.target"
            @click="goToPage(logo, $event)"
        >
          <img
              v-if="logo.properties && (logo.properties.imageCrop || logo.properties.image)"
              :src="logo.properties.imageCrop || logo.properties.image"
              v-bind="logo.properties"
              :alt="logo.properties.alt"
          />
          <strong v-else
                  :class="{'black--text': mobileOnly}"
          >{{ logo.properties['v-logo-text'] }}</strong>
        </a>
      </template>
      <template v-else>
        <img
            v-if="logo.properties && (logo.properties.imageCrop || logo.properties.image)"
            :src="logo.properties.imageCrop || logo.properties.image"
            v-bind="logo.properties"
            :alt="logo.properties.alt"
        />
        <strong v-else :class="{'black--text': mobileOnly}">{{ logo.properties['v-logo-text'] }}</strong>
      </template>
    </span>
    </span>
</template>
<script>
import globalMixins from "@/mixins/globalMixins";

export default {
  name: 'DynamicLogo',
  props: {
    context: {
      type: Object
    },
    mobileOnly: {
      type: Boolean
    },
    ready: {
      type: Boolean
    }
  },

  data() {
    return {
      logo: {
        properties: {}
      }
    }
  },

  mixins: [globalMixins],

  created() {
    if (this.context) {
      this.setLogo();
    }
  },

  methods: {
    setLogo() {
      this.logo = this._.cloneDeep(this.context);
      this.$forceUpdate();
    }
  },

  watch: {
    async 'ready'(to) {
      if (to) {
        this.setLogo();
      }
    }
  }
}
</script>